Apt.fn.make('article', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		if ($$('chart').length) {
			LS.util.load('chart', () => {
				scope.charts = Apt.chart.build();
			});
		}

		if ($$('code').length) {
			LS.util.load('code', () => {
				Apt.code.init();
			});
		}

		scope.meta = Apt.fn.meta()
			.init();
	},

	/**
	 * Unload module
	 */
	unload() {
		const scope = this;

		if (Apt.code) {
			Apt.code.unload();
		}

		if (scope.charts) {
			scope.charts.forEach(chart => {
				chart.$destroy();
			});

			scope.charts = null;
		}

		if (scope.meta) {
			scope.meta.$destroy();
		}
	}
});